import { createAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { all, takeLatest } from 'redux-saga/effects';
import { createFetchAction, createSaga, fetchInitialState, fetchReducerActions } from 'store/utils';
// import { setAuthInHeader } from 'api/config/axiosUtils';
// import storage, { keys } from 'lib/storage';
// import { RootState } from 'store';
import * as employeeApi from 'api/employee';

export const fetch_employee_list = createFetchAction('fetch_employee_list');
export const fetch_employee_list_all = createFetchAction('fetch_employee_list_all');
export const fetch_manager_list = createFetchAction('fetch_manager_list');
export const register_employee = createFetchAction('register_employee');
export const update_employee = createFetchAction('update_employee');
export const delete_employee = createFetchAction('delete_employee');
export const fetch_project_graph = createFetchAction('fetch_project_graph');
export const sign_in_by_employee = createFetchAction('sign_in_by_employee');
export const send_email_for_reset = createFetchAction('send_email_for_reset');
export const fetch_employee_by_key = createFetchAction('fetch_employee_by_key');
export const edit_employee_password = createFetchAction('edit_employee_password');

interface InitialState {
  employeeList: object | any;
  employeeListAll: object | any;
  managerList: object | any;
  registerEmployee: object | any;
  updateEmployee: object | any;
  deleteEmployee: object | any;
  prjectGraph: object | any;
  signInByEmployee: object | any;
  sendEmailForReset: object | any;
  employeeByKey: object | any;
  editEmployeePassword: object | any;
}

const initialState: InitialState = {
  // NOTE: 최초 랜딩시 storage값 유무 확인
  employeeList: { ...fetchInitialState, data: null },
  employeeListAll: { ...fetchInitialState, data: null },
  managerList: { ...fetchInitialState, data: null },
  registerEmployee: { ...fetchInitialState, data: null },
  updateEmployee: { ...fetchInitialState, data: null },
  deleteEmployee: { ...fetchInitialState, data: null },
  prjectGraph: { ...fetchInitialState, data: null },
  signInByEmployee: { ...fetchInitialState, data: null },
  sendEmailForReset: { ...fetchInitialState },
  employeeByKey: { ...fetchInitialState, data: null },
  editEmployeePassword: { ...fetchInitialState },
};

const slice = createSlice({
  name: 'employee',
  initialState,
  reducers: {
    ...fetchReducerActions(fetch_employee_list, 'employeeList'),
    ...fetchReducerActions(fetch_employee_list_all, 'employeeListAll'),
    ...fetchReducerActions(fetch_manager_list, 'managerList'),
    ...fetchReducerActions(register_employee, 'registerEmployee'),
    ...fetchReducerActions(update_employee, 'updateEmployee'),
    ...fetchReducerActions(delete_employee, 'deleteEmployee'),
    ...fetchReducerActions(fetch_project_graph, 'prjectGraph'),
    ...fetchReducerActions(sign_in_by_employee, 'signInByEmployee'),
    ...fetchReducerActions(send_email_for_reset, 'sendEmailForReset'),
    ...fetchReducerActions(fetch_employee_by_key, 'employeeByKey'),
    ...fetchReducerActions(edit_employee_password, 'editEmployeePassword'),
  },
});

export const name = slice.name;
export const actions: any = slice.actions;

export function* employeeSaga() {
  yield all([
    takeLatest(
      actions.fetch_employee_list_request,
      createSaga(actions, 'fetch_employee_list', employeeApi.fetchEmployeeList, {
        isApiLoading: false,
      }),
    ),
    takeLatest(
      actions.fetch_employee_list_all_request,
      createSaga(actions, 'fetch_employee_list_all', employeeApi.fetchEmployeeListAll, {
        isApiLoading: false,
      }),
    ),
    takeLatest(
      actions.fetch_manager_list_request,
      createSaga(actions, 'fetch_manager_list', employeeApi.fetchManagerList),
    ),
    takeLatest(
      actions.register_employee_request,
      createSaga(actions, 'register_employee', employeeApi.registerEmployee),
    ),
    takeLatest(
      actions.update_employee_request,
      createSaga(actions, 'update_employee', employeeApi.updateEmployee),
    ),
    takeLatest(
      actions.delete_employee_request,
      createSaga(actions, 'delete_employee', employeeApi.deleteEmployee),
    ),
    takeLatest(
      actions.fetch_project_graph_request,
      createSaga(actions, 'fetch_project_graph', employeeApi.fetchProjectGraph),
    ),
    takeLatest(
      actions.sign_in_by_employee_request,
      createSaga(actions, 'sign_in_by_employee', employeeApi.signInByEmployee, {
        isAlertfailure: false,
      }),
    ),
    takeLatest(
      actions.send_email_for_reset_request,
      createSaga(actions, 'send_email_for_reset', employeeApi.sendEmailForReset, {
        isAlertSuccess: true,
        isAlertfailure: false,
      }),
    ),
    takeLatest(
      actions.fetch_employee_by_key_request,
      createSaga(actions, 'fetch_employee_by_key', employeeApi.fetchEmployeeBykey),
    ),
    takeLatest(
      actions.edit_employee_password_request,
      createSaga(actions, 'edit_employee_password', employeeApi.editEmployeePassword, {
        isAlertSuccess: true,
      }),
    ),
  ]);
}

export default slice.reducer;
